export function isJSON(text) {
  const rxOne = /^[\],:{}\s]*$/;
  const rxTwo = /\\(?:["\\/bfnrt]|u[0-9a-fA-F]{4})/g;
  const rxThree =
    /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\\-]?\d+)?/g;
  const rxFour = /(?:^|:|,)(?:\s*\[)+/g;
  const isJSONResult = (input) =>
    input.length &&
    rxOne.test(
      input.replace(rxTwo, "@").replace(rxThree, "]").replace(rxFour, "")
    );
  return isJSONResult(text);
}

export default function areEqual(obj1, obj2) {
  // Verificar si ambos parámetros son objetos
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1 === obj2;
  }

  // Verificar si los objetos son null o undefined
  if (
    obj1 === null ||
    obj2 === null ||
    obj1 === undefined ||
    obj2 === undefined
  ) {
    return obj1 === obj2;
  }

  // Verificar si tienen la misma cantidad de propiedades
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  const keys = Object.keys(obj1);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
      return false;
    }
    if (!areEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
export function isTrue(obj) {
  return (
    obj !== null &&
    obj !== false &&
    obj !== undefined &&
    Object.keys(obj).length > 0
  );
}

export function getAllContents(content) {
  const patron = /<([^\/\s>]+)([^>]*)>(.*?)<\/\1>/gs;
  const matches = Array.from(content.matchAll(patron));

  if (matches.length === 0) {
    return [content];
  }

  const contenido = [];
  let lastIndex = 0;

  for (const match of matches) {
    if (match.index > lastIndex) {
      const textBefore = content.slice(lastIndex, match.index).trim();
      if (textBefore) {
        contenido.push(textBefore);
      }
    }

    const innerContent = match[3].trim();
    if (innerContent) {
      contenido.push(innerContent);
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    const textAfter = content.slice(lastIndex).trim();
    if (textAfter) {
      contenido.push(textAfter);
    }
  }

  return contenido;
}

export function extraerContenidoHTML(html) {
  const regex = />([^<]*)</g;
  let contenido = [];
  let match;

  while ((match = regex.exec(html)) !== null) {
    if (match[1].trim()) {
      contenido.push(match[1].trim());
    }
  }

  if (contenido.length === 0) {
    let resultado = html;
    resultado = resultado.replace(/<\/?[^>]+>/g, "");
    resultado = resultado.replace(/\s{3,}/g, ". ");
    resultado = resultado.replace(/\n/g, " ");
    resultado = resultado.replace(/\s{2,}/g, " ");
    return resultado.trim();
  }

  let resultado = contenido.join(" ");
  resultado = resultado.replace(/\s{3,}/g, ". ");
  resultado = resultado.replace(/\n/g, " ");
  resultado = resultado.replace(/\s{2,}/g, " ");

  return resultado.trim();
}
export async function validateImageEnabled(imageUrl) {
  const img = new Image();
  img.src = imageUrl;

  await new Promise((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = (error) => reject(error);
  });
  return;
}

export const debounce = (func, wait) => {
  let timeout;
  const executedFunction = (...args) => {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
  return executedFunction;
};
export const handleLinkClick = (url) => {
  window.open(url, "_blank");
};
export const handleMailClick = (email) => {
  if (!email) return;
  const mailHost = "mailto:";
  return handleLinkClick(mailHost + email);
};
export const handleMapClick = (branch_address) => {
  if (!branch_address) return;
  const mapHost = "https://www.google.com/maps/search/?api=1&query=";
  return handleLinkClick(mapHost + branch_address.replace(" ", "+"));
};
export const handleWhatsappClick = (whatsapp) => {
  if (!whatsapp) return;
  const whatsappHost = "https://api.whatsapp.com/send/?phone=";
  return handleLinkClick(whatsappHost + cleanNumberToWhastapp(whatsapp));
};
export const cleanNumberToWhastapp = (number) => {
  const cleanedNumber = number.replace(/\D/g, "").trim();
  return cleanedNumber;
};
